export const NOTIFICATION_CHANGE_TYPE = 'CHANGE_TYPE'
export const NOTIFICATION_CHANGE_TYPE_FILTER = 'NOTIFICATION_CHANGE_TYPE_FILTER'
export const NOTIFICATION_CHANGE_DATE_FILTER = 'NOTIFICATION_CHANGE_BEFORE_FILTER'
export const NOTIFICATION_FILTER_SEARCH = 'NOTIFICATION_FILTER_SEARCH'
export const NOTIFICATION_FILTER_FIELD_CHANGED = 'NOTIFICATION_FILTER_FIELD_CHANGED'
export const NOTIFICATION_CHANGE_SEARCH_TEXT = 'NOTIFICATION_CHANGE_SEARCH_TEXT'
export const NOTIFICATION_CHANGE_LIMIT = 'NOTIFICATION_CHANGE_LIMIT'

export interface INotificationsState {
  currentType: any
  searchText: string
  before: number | null
  after: number | null
  type: number | null
  limit: number
}

const initialState: INotificationsState = {
  currentType: null,
  searchText: '',
  before: null,
  after: null,
  type: null,
  limit: 10,
}
export default function notificationsReducer(
  state: INotificationsState = initialState,
  action: any,
): INotificationsState {
  switch (action.type) {
    case NOTIFICATION_CHANGE_TYPE:
      return { ...state, currentType: action.payload, limit: 10 }
    case NOTIFICATION_CHANGE_SEARCH_TEXT:
      return { ...state, searchText: action.payload, limit: 10 }
    case NOTIFICATION_CHANGE_TYPE_FILTER:
      return { ...state, type: action.payload, limit: 10 }
    case NOTIFICATION_CHANGE_DATE_FILTER:
      return {
        ...state,
        before: action.payload.before,
        after: action.payload.after,
        limit: 10,
      }
    case NOTIFICATION_CHANGE_LIMIT:
      return { ...state, limit: state.limit + 10 }
    default:
      return state
  }
}
